module.exports = __webpack_public_path__ + "static/media/planner-s.9eb93967.svg";